import styled from 'styled-components';

export const ScrollableWrapper = styled.div`
  overflow-y: scroll;
`;
